import * as Sentry from '@sentry/browser';

function gtmError(error, object) {
    Sentry.configureScope(scope => {
        if (error && error.config) {
            scope.setExtra("url", error.config.url);
            scope.setExtra("method", error.config.method);
            scope.setExtra("request_data", error.config.data);
        }

        if (error && error.response) {
            scope.setExtra("response_data", error.response.data);
            scope.setExtra("status", error.response.status);
            scope.setExtra("headers", error.response.headers);
        }

        if (error && error.message) {
            scope.setExtra("message", error.message);
        }

        scope.setExtra("params", object);

        Sentry.captureException(error);
    });
}

export default gtmError;